import { useMsal } from '@azure/msal-react'
import { ShieldX } from 'lucide-react'
import { useBrandingStore } from '../stores/branding'

export default function AccessDeniedPage() {
  const { instance } = useMsal()
  const { name } = useBrandingStore()

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="h-8 w-8 text-destructive" />
          </div>
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-foreground">Access Denied</h1>
          <p className="text-sm text-muted-foreground">
            Your request to access <strong>{name}</strong> has been denied.
            Contact an administrator if you believe this is a mistake.
          </p>
        </div>
        <button
          onClick={() => instance.logoutRedirect()}
          className="text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
